module.exports = __webpack_public_path__ + "f3b0d6cf60cc2b259edf36b39438e2bf.glb";